import { ediphiPalette } from "./colors";

/**
 * Reserved track width. Pinned in CSS rather than inherited, so it is the same on Windows
 * WebView2 and macOS WKWebView — which is what lets a caller compensate its padding by a
 * fixed amount. Anything subtracting this from a padding must read it from here.
 *
 * Invariant: a container that compensates its padding or margin for the track must also reserve
 * the track unconditionally — `overflow-y: scroll`, never `auto`. With `auto` the bar only exists
 * once content overflows, so the compensation is wrong whenever it does not, and edges jump as
 * content crosses the threshold.
 */
export const SCROLLBAR_WIDTH = 8;

const TRACK_WIDTH = `${SCROLLBAR_WIDTH}px`;
const THUMB_INSET = "2px";

/**
 * Slim scrollbar for elements that scroll. `TRACK_WIDTH` is the only part that affects layout;
 * the transparent border plus `background-clip: content-box` shrinks the painted thumb to
 * TRACK_WIDTH - 2 * THUMB_INSET so it reads as a floating pill rather than a system bar.
 *
 * Note this opts macOS out of overlay scrollbars, so the track is reserved on every platform.
 */
export const thinScrollbarSx = {
  "&::-webkit-scrollbar": {
    width: TRACK_WIDTH,
    height: TRACK_WIDTH,
  },
  "&::-webkit-scrollbar-track": {
    background: "transparent",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: ediphiPalette.ediphiTabButtonBorder,
    border: `${THUMB_INSET} solid transparent`,
    backgroundClip: "content-box",
    borderRadius: TRACK_WIDTH,
  },
  "&::-webkit-scrollbar-thumb:hover": {
    backgroundColor: ediphiPalette.greyText,
  },
  "&::-webkit-scrollbar-corner": {
    background: "transparent",
  },
};
